"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AGENT_HEADER_KEY = void 0;
exports.USER_AGENT_HEADER_KEY = "x-snap-client-user-agent";
//# sourceMappingURL=headers.js.map